import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DependentCard from "./DependentCard";

function RequestModal(props) {
  const { data, type, relationData } = props;

  return (
    <Modal {...props} backdrop="static" size="xl" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Dependent Request List</Modal.Title>
        <Button onClick={props.handleClose}>x</Button>
      </Modal.Header>
      <Modal.Body>
        <DependentCard data={data}/>
      </Modal.Body>
    </Modal>
  );
}

export default RequestModal;
